export const getErrorFromLocation = (location = window.location) => {
  const errorId = new URLSearchParams(location.search).get('error')

  if (!errorId) {
    return null
  }

  switch (errorId) {
    case 'user-invalid-username':
      return {
        id: errorId,
        message: 'A user in this team already has the same username',
      }
    case 'auth/unauthorized/sso-domain-unauthorized':
      return {
        id: errorId,
        message:
          'This account does not have an authorized email for this team. Contact your team admin or select another account.',
      }
    case 'auth/user-unknown':
      return {
        id: errorId,
        message: 'This user is unknown in this team',
      }
    case 'auth/unauthorized/expired':
      return {
        id: errorId,
        message: 'Your credentials have expired.',
      }
    case 'invalid-sso-refresh':
      return {
        id: errorId,
        message:
          'Refreshing your auth tokens failed. Please try again or contact the support if the problem persists.',
      }
    case 'org-mismatch':
      return {
        id: errorId,
        message: 'Authorizations token do not match current team.',
      }
    default:
      return null
  }
}

export const getReturnToFromLocation = (
  location = window.location,
  appDomain
) => {
  const returnToQuery = new URLSearchParams(location.search).get('returnTo')

  if (!location || !location.search || !returnToQuery) {
    return null
  }
  const returnTo = decodeURIComponent(returnToQuery)

  // Relative url, doesn't need any check
  if (returnTo.startsWith('/')) {
    return returnTo
  }

  try {
    // eslint-disable-next-line no-useless-escape
    const regex = new RegExp(`^(.+\.)?${appDomain}`)
    const { host } = new URL(returnTo)

    const urlDomainMatchesAppDomain = regex.test(host)

    if (!urlDomainMatchesAppDomain) {
      return
    }

    return returnTo
  } catch (error) {}
}
